import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const SelectFromValueList = ({
  options,
  value,
  placeholder = "Select an option",
  onValueChange,
}) => {
  const renderSelectItem = (option) => {
    if (typeof option === 'string') {
      return (
        <SelectItem key={option} value={option}>
          {option}
        </SelectItem>
      );
    }
    return (
      <SelectItem key={option.value} value={option.value}>
        {option.label}
      </SelectItem>
    );
  };

  return (
    <div className="w-72">
      <Select 
        value={value} 
        onValueChange={onValueChange}
      >
        <SelectTrigger>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map(renderSelectItem)}
        </SelectContent>
      </Select>
    </div>
  );
};

export { SelectFromValueList }